import * as React from "react";
import { forwardRef } from "react";
const SvgChevronUp = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 16, fill: "currentColor", viewBox: "0 0 17 16", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.47 5.47a.75.75 0 0 1 1.061 0l3 3a.75.75 0 1 1-1.06 1.06L8 7.06 5.53 9.53a.75.75 0 1 1-1.06-1.06l3-3Z" }));
const ForwardRef = forwardRef(SvgChevronUp);
export default ForwardRef;
